// extracted by mini-css-extract-plugin
export var cover = "HeroLayoutCover-module--cover--05474";
export var hasVideo = "HeroLayoutCover-module--hasVideo--c4396";
export var image = "HeroLayoutCover-module--image--bb7f4";
export var largePlaceholder = "HeroLayoutCover-module--largePlaceholder--7053e";
export var logo = "HeroLayoutCover-module--logo--65cb9";
export var noMargin = "HeroLayoutCover-module--noMargin--a0604";
export var placeholder = "HeroLayoutCover-module--placeholder--943a0";
export var staticCoverImage = "HeroLayoutCover-module--staticCoverImage--633a2";
export var videoCover = "HeroLayoutCover-module--videoCover--9d7b1";